import { render, staticRenderFns } from "./ProviderServicesTableModal.vue?vue&type=template&id=be39c3a2&scoped=true&"
import script from "./ProviderServicesTableModal.vue?vue&type=script&lang=js&"
export * from "./ProviderServicesTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be39c3a2",
  null
  
)

export default component.exports